<template>
  <div id="one-philly-home-page">
    <Welcome />
    <div class="homepage-container">
      <ServiceStatus />
      <Announcements />
      <PopularServices />
      <PhillyStat360 />
      <Tools />
      <Featured />
      <Services />
      <Philly311 />
      <CleanGreen />
      <Mayor />
      <CityCouncil />
      <StayConnected />
    </div>
  </div>
</template>

<script>
import Welcome from "./components/Welcome.vue";
import ServiceStatus from "./components/ServiceStatus.vue";
import PopularServices from "./components/PopularServices.vue";
import Tools from "./components/Tools.vue";
import Featured from "./components/Featured.vue";
import CleanGreen from "./components/CleanGreen.vue";
import Services from "./components/Services.vue";
import StayConnected from "./components/StayConnected.vue";
import Philly311 from "./components/Philly311.vue";
import Mayor from "./components/Mayor.vue";
import CityCouncil from "./components/CityCouncil.vue";
import PhillyStat360 from "./components/PhillyStat360.vue";
import { loadLanguageAsync } from './i18n.js';
import Announcements from "./components/Announcements.vue";

export default {
  name: "App",
  components: {
    Welcome,
    Announcements,
    ServiceStatus,
    PopularServices,
    PhillyStat360,
    Tools,
    Featured,
    Services,
    Philly311,
    CleanGreen,
    Mayor,
    CityCouncil,
    StayConnected,
  },
  data() {
    return {
      loading: true, // Add a loading state
    };
  },
  computed: {
    currentRouteName() {
      return this.isTranslated(window.location.pathname);
    },

    language() {
      let lang = this.isTranslated(window.location.pathname);
      const validLanguages = [ '/es', '/zh', '/ar', '/ht', '/fr', '/sw', '/pt', '/ru', '/vi' ];
      if (validLanguages.includes(lang)) {
        return lang.substring(1);
      }
      return 'en';
    },
  },
  async mounted() {
    // Wait for the language data to load before rendering the content
    await loadLanguageAsync(this.language);
    this.loading = false; // Set loading to false once language data is loaded
  },
  methods: {
    isTranslated(path) {
      let splitPath = path.split("/");
      const langList = [
        'zh', 'es', 'ar', 'fr', 'ru', 'ms', 'hi', 'pt', 'bn', 'id', 'sw',
        'ja', 'de', 'ko', 'it', 'fa', 'tr', 'nl', 'te', 'vi', 'ht',
      ];
      for (let i = 0; i < splitPath.length; i++) {
        if (langList.indexOf(splitPath[i]) > -1) {
          return '/' + splitPath[i];
        }
      }
      return null;
    },

    translateLink(link) {
      let self = this;
      if (link.includes('http')) {
        return link;
      }
      return self.currentRouteName ? self.currentRouteName + link : link;
    },
  },
};
</script>
